module.exports = __webpack_public_path__ + "static/img/shouye_banner.mingshi.03671b97.png";